/* 财务-专线订单 */
<template>
  <div id="financial">
    <finance-summary-card
      summary-url="/api/v1/manage/financeFlowing/summary"
      :params="summaryParams"
    />
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
       labelWidth="95" excel-type="FinanceFlowing" :summaryList="[
        { name: 'orderFee', beforeUnit: '￥' },
        { name: 'couponFee', beforeUnit: '￥' },
        { name: 'realFee', beforeUnit: '￥' },
        { name: 'driverIncome', beforeUnit: '￥' },
        { name: 'companyIncome', beforeUnit: '￥' },
      ]"
      @search="p => summaryParams = { ...p }">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime
        }}</template>
        <template v-else-if="item.prop === 'paymentTime'">{{
          row.paymentTime | filterTime
        }}</template>
      <template v-else-if="item.prop === 'startStationName'">{{ row.startStationName }} - {{ row.endStationName }}
        </template>
        <!-- <template v-else-if="item.prop === 'startStationName'"
                  >{{ row.startStationName }} - {{ row.endStationName }}
                </template> -->
        <template v-else-if="item.prop === 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
        <template v-else-if="item.prop === 'startLineTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }} - {{ row.endLineTime }}
        </template>
        <template v-else-if="item.prop === 'realFee'">
          <span class="util-money" v-if="row.realFee || row.realFee === 0">{{
            row.realFee
          }}</span>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'orderFee'">
          <span class="util-money" v-if="row.orderFee || row.orderFee === 0">{{
            row.orderFee
          }}</span>
          <span v-if="!row.orderFee && row.orderFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'couponFee'">
          <span class="util-money" v-if="row.couponFee || row.couponFee === 0">{{ row.couponFee }}</span>
          <span v-if="!row.couponFee && row.couponFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'channelAlias'">
          <span>{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee === 0">{{
            row.lineFee
          }}</span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'driverIncome'">
          <template v-if="row.driverIncome || row.driverIncome === 0">
            <span class="util-money">{{ row.driverIncome }}</span>
            <span v-if="row.commissionRuleType == 1">
              {{
                row.proportion ? "(" + row.proportion + "%提成" + ")" : ""
              }}</span>
            <span v-if="row.commissionRuleType == 2"> (定额提成)</span>
          </template>

          <span v-if="!row.driverIncome && row.driverIncome !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'companyIncome'">
          <span class="util-money" v-if="row.companyIncome || row.companyIncome === 0">{{ row.companyIncome }}</span>
          <span v-if="!row.companyIncome && row.companyIncome !== 0">-</span>
          {{ row.ticketChangingProportion ? "(" + row.ticketChangingProportion + "%改签费率" + ")" : "" }}
          {{ row.refundType != 2 && row.refundProportion ? "(" + row.refundProportion + "%退票费率" + ")" : "" }}
          {{ row.refundType == 2 ? "(平台操作)" : "" }}
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
import FinanceSummaryCard from './components/financeSummaryCard.vue'
export default {
  name: "financial",
  components: { FinanceSummaryCard },
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/financeFlowing",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "serialNo", name: "流水号", value: "" },
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          {
            type: "select",
            field: "channelAlias",
            name: "订单来源",
            value: "",
            option: this.$const.CHANNELALIAS,
          },
          {
            type: "select",
            field: "incomeType",
            name: "收入类型",
            value: "",
            option: this.$const.INCOM_TYPE,
          },
          { type: "input", field: "licenseNo", name: "车辆信息", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "customerPhone", name: "乘客手机号", value: "" },
          { type: "datetime", field: "payTime", dateProp: { start: "payStartTime", end: "payEndTime" }, name: "支付时间", value: [] },
          { type: "datetime", field: "time", name: "完单时间", value:[new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)] },
        ],
      },
      summaryParams: {},
      // 表头
      columns: [
        { prop: "serialNo", label: "流水号", width: 200 },
        { prop: "orderNo", label: "订单号", width: 200 },
        { prop: "channelAlias", label: "订单来源" },
        { prop: "incomeType", label: "收入类型" },
        { prop: "licenseNo", label: "车辆号牌", width: 100 },
        { prop: "vehicleNo", label: "车辆编号", width: 100 },
        { prop: "driverName", label: "司机姓名" },
        { prop: "startStationName", label: "线路名称", width: 250 },
        { prop: "startLineTime", label: "班次", width: 140 },
        { prop: "passengerNum", label: "乘车人数", width: 70 },
        { prop: "lineFee", label: "车票价格" },
        { prop: "orderFee", label: "订单总价" },
        { prop: "couponFee", label: "优惠券折扣", width: 100 },
        { prop: "realFee", label: "实付金额" },
        { prop: "driverIncome", label: "司机收入", width: 130 },
        { prop: "companyIncome", label: "平台收入", width: 150 },
        { prop: "customerPhone", label: "乘客手机号", width: 120 },
        { prop: "paymentTime", label: "支付时间", width: 130 },
        { prop: "created", label: "完单时间", width: 130 },
      ],
    };
  },
};
</script>

<style scoped></style>
